module.exports = "https://static.wmbcdn.com/uniweb/images/2ab45b0075a94f7ad6889a3dc1ef05a9.svg";